import { IconFont, Text } from '@lighthouse/bui'
import styled, { css, keyframes } from 'styled-components'

export const Container = styled.div<{ width?: number }>`
    width: ${({ width }) => (width ? `${width}px` : 'auto')};
    box-sizing: border-box;
    padding: 8px 12px 8px 12px;
    border-radius: 12px;
    background: var(--color-white);
`

// 定义旋转动画
const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const Icon = styled(IconFont)<{ color?: string; animation?: boolean }>`
    font-size: 24px;
    color: ${({ color }) => color || 'var(--color-white)'};
    ${({ animation }) =>
        animation
            ? css`
                  animation: ${rotate360} 3s linear infinite;
              `
            : css`
                  animation: none;
              `}
`

export const Header = styled.div`
    padding: 6px 0;
    min-height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const HeaderLeft = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
    overflow: hidden;
`

export const Logo = styled.div<{ background?: string }>`
    width: 24px;
    height: 24px;
    border-radius: 4px;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    background: ${({ background }) => background || '#2E90FA'};
`

export const NodeName = styled.div`
    color: var(--color-gray-900);
    font-size: 14px;
    font-weight: 600;
    margin-left: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const HeaderRight = styled.div`
    width: 12px;
    height: 12px;
    display: flex;
    align-items: center;
`

export const Content = styled.div``

export const Footer = styled.div`
    margin: 6px 0;
    color: var(--color-gray-500);
    font-size: 12px;
    line-height: 20px;
`

export const FieldItemTitle = styled(Text)<{ color?: string }>`
    color: ${({ color }) => color || 'var(--color-gray-600)'};
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
`

export const FieldList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`

export const FieldItem = styled.div`
    height: 28px;
    background: #eceff4;
    border-radius: 4px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
`

export const FieldItemContent = styled.div`
    min-height: 28px;
    background: #eceff4;
    border-radius: 4px;
    padding: 4px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
`
export const FieldItemLeftFill = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    overflow: hidden;
    flex: 1;
`

export const CardItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 6px 0;
`

export const CardContainer = styled.div``
